import {
  PrimaryColor,
  ThemeMode,
  UserConfigKey,
} from '../../../shared/constants';
import { DEFAULT_MEASUREMENT_UNIT_BY_PARAMETER } from '../../../shared/constants/user-measurements';
import { ICompleteRegistrationBody } from '../../../types/interfaces/complete-registration';
import { ILanguage } from '../../../types/interfaces/language';
import { IUser } from '../../../types/interfaces/user';
import { IUpsertMeasurementBody } from '../../../types/interfaces/user-measurement';
import { getTodayMeasuredDate } from '../../../utils/measurements/measurement-utils';
import { IRegistrationWizardValues } from './complete-registration.types';

function buildMeasurements(
  values: IRegistrationWizardValues,
): IUpsertMeasurementBody[] | undefined {
  const measuredDate = getTodayMeasuredDate();
  const items: IUpsertMeasurementBody[] = [];

  if (values.weightValue !== '' && values.weightValue != null) {
    items.push({
      parameter: 'weight',
      measuredDate,
      value: Number(values.weightValue),
      unitKey: values.weightUnitKey,
    });
  }

  if (values.heightValue !== '' && values.heightValue != null) {
    items.push({
      parameter: 'height',
      measuredDate,
      value: Number(values.heightValue),
      unitKey: values.heightUnitKey,
    });
  }

  return items.length ? items : undefined;
}

function buildConfig(values: IRegistrationWizardValues) {
  return [
    { key: UserConfigKey.theme, value: values.theme },
    { key: UserConfigKey.primaryColor, value: values.primaryColor },
  ];
}

export function buildRegistrationCompletionBody(
  values: IRegistrationWizardValues,
  options: { includeConfig: boolean },
): ICompleteRegistrationBody {
  return {
    firstname: values.firstname.trim(),
    lastname: values.lastname.trim(),
    measurements: buildMeasurements(values),
    config: options.includeConfig ? buildConfig(values) : undefined,
  };
}

export function buildRegistrationUserUpdateBody(
  values: IRegistrationWizardValues,
  language: ILanguage | null,
) {
  return {
    languageId: language?.id,
    accessConfig: {
      scope: values.scope,
      postsScope: values.postsScope,
      commentsScope: values.commentsScope,
    },
  };
}

export function getDefaultWizardValues(options: {
  firstname?: string;
  lastname?: string;
  theme: ThemeMode;
  primaryColor: PrimaryColor;
  language: ILanguage | undefined;
  accessConfig?: IUser['accessConfig'];
}): IRegistrationWizardValues {
  return {
    firstname: options.firstname ?? '',
    lastname: options.lastname ?? '',
    weightValue: '',
    weightUnitKey: DEFAULT_MEASUREMENT_UNIT_BY_PARAMETER.weight,
    heightValue: '',
    heightUnitKey: DEFAULT_MEASUREMENT_UNIT_BY_PARAMETER.height,
    theme: options.theme,
    primaryColor: options.primaryColor,
    language: options.language ?? null,
    scope: options.accessConfig?.scope,
    postsScope: options.accessConfig?.postsScope,
    commentsScope: options.accessConfig?.commentsScope,
  };
}
